<ckeditor #ckEditor (ngModelChange)="change($event)" (ready)="onReady($event)" (focus)="focusEditor()"
  [class.h-full]="autoHeight" [class.hide-toolbar]="!showToolbar" [class]="customClass" [config]="config"
  [style.min-height]="minHeight" [disabled]="disabled || isDisabled" [editor]="Editor" [maxlength]="limit.textLimit"
  [ngClass]="loadingClass" [ngModel]="value  ?? ' '" [ngStyle]="styles">
</ckeditor>